export default __webpack_public_path__ + "static/success-stories-banner-bg-d1015e554be2b489ef8888a0722344d0.jpg";